import Layout from "@/layout/Layout.vue";
import { P } from "@/config/permissions";

/**
 * Gestion de projet — projets kanban par équipe.
 *
 * `noCache` sur le projet : l'écran se recharge à chaque entrée. Un kanban
 * gardé en cache afficherait des tâches déplacées entre-temps par quelqu'un
 * d'autre, ce qui est pire qu'un rechargement.
 *
 * Le droit sur les processus ouvre la branche parce que « Mes tâches » y réunit
 * les tâches et les étapes de processus assignées : quelqu'un qui ne suit que des
 * processus doit pouvoir atteindre sa liste. Les autres écrans du module gardent
 * `browse projets` et restent donc invisibles pour lui — les enfants sont filtrés
 * un par un.
 */
const projetsRoutes = {
    path: "/projets",
    name: "projets-root",
    component: Layout,
    redirect: "/projets/tableaux",
    alwaysShow: true,
    meta: {
        title: "Projets",
        icon: "mdi:view-dashboard-outline",
        permissions: [P.PROJETS.BROWSE, P.PROCESSUS.BROWSE]
    },
    children: [
        {
            // En tête de menu : c'est l'écran qu'on ouvre le matin, avant même
            // de savoir dans quel projet se trouve ce qui presse.
            path: "mes-taches",
            name: "projets-mes-taches",
            meta: {
                title: "Mes tâches",
                icon: "mdi:format-list-checks",
                permissions: [P.PROJETS.BROWSE, P.PROCESSUS.BROWSE],
                noCache: true,
                // Pastille : mes notifications projets non lues (carte confiée,
                // mention, commentaire, échéance). Personnelle, comme la cloche.
                badgeKey: "projets"
            },
            component: () => import("@/views/projets/MesTaches.vue")
        },
        {
            // Le chemin garde son ancien nom : les notifications déjà envoyées
            // pointent dessus, et un lien mort vaut moins qu'un mot daté dans
            // une URL que personne ne lit.
            path: "tableaux",
            name: "projets",
            meta: {
                title: "Tous les projets",
                icon: "mdi:view-dashboard-outline",
                permissions: [P.PROJETS.BROWSE],
                noCache: true
            },
            component: () => import("@/views/projets/ProjetsListe.vue")
        },
        {
            // Ouvert depuis la liste : pas d'entrée de menu propre.
            path: "tableaux/:id",
            name: "projet-board",
            hidden: true,
            meta: {
                title: "Projet",
                permissions: [P.PROJETS.BROWSE],
                noCache: true,
                activeMenu: "/projets/tableaux"
            },
            component: () => import("@/views/projets/ProjetBoard.vue")
        },
        {
            path: "equipes",
            name: "projets-equipes",
            meta: {
                title: "Équipes",
                icon: "mdi:account-group-outline",
                permissions: [P.EQUIPES.BROWSE, P.PROJETS.BROWSE],
                noCache: true
            },
            component: () => import("@/views/projets/Equipes.vue")
        }
        // Le journal d'audit du module n'est pas ici : il est rangé avec les
        // autres journaux, dans le bloc Administration, dont l'accès est déjà
        // restreint. Voir `admin.js`, entrée « Audit — gestion de projet ».
    ]
};

export default projetsRoutes;
